import {
	Card,
	Row,
	Col,
	Image
} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

const ClickToView = () => {
	const { t } = useTranslation()
	return (
		<>
			<Card>
				<Card.Body style={{ minHeight: '150vh', paddingTop: '200px' }}>
					<Row className='justify-content-center'>
						<Col style={{ textAlign: 'center' }}>
							<Image src='/img/landing_page/jobs-at-southeast.png' alt='view job details' width='300' /><br /><br /><br />
							<p className='text-center'><strong>{t('job_list.Select_a_job_to_view_details')}</strong></p>
						</Col>
					</Row>
				</Card.Body>
			</Card>
		</>
	)
}

export default ClickToView